import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import swal from "sweetalert";
import {
	Row,
	Col,
	Button,
	Container,
	Card,
	CardBody,
	CardTitle,
	Table,
	// Label,
	Form,
	FormGroup,
	InputGroup,
} from "reactstrap";
import PageTitle from "../../../Layout/AppMain/PageTitle";
import {
	useGetCurrentDateQuery,
	useGetJobsClosureQuery,
	useUpdateTimeJobsClosureMutation,
} from "../../../Api/helpersApi";
import toastifyAlert from "../../../components/ToastifyAlert";
import { toast } from "react-toastify";
import { formatDateZone } from "../../../utilities/utilities";
import { formatHourToHHMM } from "../../../utilities/formatTime";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";

// configure toast
const configure = {
	theme: "dark",
	position: "bottom-center",
	className: "black-background",
};

// validate form
const validate = values => {
	const errors = {};
	if (!values.execution_time) {
		errors.execution_time = "Campo Requerido";
	} else {
		// Validar que la hora seleccionada no sea menor a la hora actual
		const now = new Date();
		const selectedTime = values.execution_time;

		// Crear fecha de hoy con la hora seleccionada para comparar
		const todayWithSelectedTime = new Date();
		todayWithSelectedTime.setHours(selectedTime.getHours());
		todayWithSelectedTime.setMinutes(selectedTime.getMinutes());
		todayWithSelectedTime.setSeconds(0);
		todayWithSelectedTime.setMilliseconds(0);

		// Si la hora seleccionada es menor a la actual del mismo día
		if (todayWithSelectedTime <= now) {
			errors.execution_time = "La hora debe ser mayor a la hora actual";
		}
	}
	return errors;
};

const TimeChangeJobsClosurePage = () => {
	/* Initializers  */
	const navigate = useNavigate();

	/* redux toolkit RKT methods for making API requests */
	const { data: currentDateData } = useGetCurrentDateQuery();
	const { data, error, isLoading, refetch } = useGetJobsClosureQuery();
	const [updateTimeJobsClosure] = useUpdateTimeJobsClosureMutation();

	// Helper function to format time for API
	const formatTimeForAPI = date => {
		if (!date) return "";
		const hours = date.getHours().toString().padStart(2, "0");
		const minutes = date.getMinutes().toString().padStart(2, "0");
		return `${hours}:${minutes}`;
	};

	// Helper function to filter available times (only future times)
	const filterPassedTime = time => {
		const currentDate = new Date();
		const selectedDate = new Date(time);

		return currentDate.getTime() < selectedDate.getTime();
	};

	/**
	 * It's a function that makes an API call to a server and returns a result.
	 */
	const postSearch = async e => {
		try {
			const bodyData = {
				execution_time: formatTimeForAPI(e.execution_time),
				company_code: "8",
			};

			await toast.promise(
				updateTimeJobsClosure({ data: bodyData }).unwrap(),
				{
					pending: "Cargando...",
				},
				configure,
			);
			// Refetch data to get updated jobs closure times
			refetch();
			// Reset form after submission
			handleResetForm();
			// Show success message
			toastifyAlert("Los cambios se guardaron correctamente", "success");
		} catch (err) {
			if (err?.data?.detail) {
				toastifyAlert(`Error: ${err.data.detail}`, "error");
			} else if (err?.data?.message) {
				toastifyAlert(`Error: ${err.data.message}`, "error");
			} else {
				toastifyAlert("🤯 Error: El Servidor no Responde", "error");
			}
		}
	};

	// define formik object
	const formik = useFormik({
		initialValues: {
			execution_time: null,
		},
		validate,
		onSubmit: value => {
			swal({
				title: "¿Desea actualizar?",
				// text: "¡No podrás revertir esto!",
				icon: "info",
				buttons: ["Cancelar", "Si, actualizar!"],
				infoMode: true,
			}).then(async confirm => {
				if (confirm) await postSearch(value);
			});
		},
	});

	// handle reset function to clear all form inputs
	const handleResetForm = () => {
		formik.resetForm();
	};

	return (
		<Fragment>
			<PageTitle
				heading="Jobs de Cierre - Cambio de Tiempo"
				icon="lnr-database icon-gradient bg-tempting-azure"
			/>

			<Container fluid>
				<Row>
					<Card>
						<CardBody>
							<CardTitle tag="h3" className="text-center mb-3 mb-3 mt-3">
								<p>Jobs de Cierre - Cambio de hora de ejecucion</p>
								<p>
									Fecha del modulo:{" "}
									{currentDateData?.current_date
										? formatDateZone(currentDateData.current_date, "DD/MM/YYYY")
										: "Cargando..."}
								</p>
							</CardTitle>

							<Row>
								<Table>
									<thead>
										<tr>
											<th>#</th>
											<th>Job</th>
											<th>Hora ejecución</th>
											<th>Próxima ejecución</th>
										</tr>
									</thead>
									<tbody>
										{isLoading && (
											<tr>
												<td colSpan={4} className="text-center">
													Cargando...
												</td>
											</tr>
										)}
										{error && (
											<tr>
												<td colSpan={4} className="text-center">
													Error al cargar los datos
												</td>
											</tr>
										)}
										{data?.data &&
											data.data.map(item => (
												<tr key={item.id}>
													<th scope="row">{item.orden_ejecucion}</th>
													<td>{item.nombre}</td>
													<td>{formatHourToHHMM(item.hora_inicio)}</td>
													<td>
														{" "}
														{formatDateZone(
															item.fecha_proxima_ejecucion,
															"DD/MM/YYYY - HH:mm:ss",
														)}
													</td>
												</tr>
											))}
									</tbody>
								</Table>
							</Row>
							{/* <Row>
								<Col className="text-center">
									<p className="text-muted">
										* La hora de ejecución corresponde a la hora local del
										servidor.
									</p>
								</Col>
							</Row> */}
							<Row className="mt-4 mb-2">
								<Col className="text-center">
									<h5 className="font-weight-bold">
										Cambiar hora de ejecución
									</h5>
								</Col>
							</Row>
							<Form onSubmit={formik.handleSubmit}>
								<Row className="d-flex justify-content-center">
									<Col md={4}>
										<FormGroup>
											{/* <Label for="execution_time">Hora de ejecución</Label> */}
											<InputGroup>
												<div className="input-group-text">
													<FontAwesomeIcon icon={faCalendarAlt} />
												</div>
												<DatePicker
													selected={formik.values.execution_time}
													onChange={date => {
														formik.setFieldValue("execution_time", date);
													}}
													onBlur={() =>
														formik.setFieldTouched("execution_time", true)
													}
													showTimeSelect
													showTimeSelectOnly
													className={`form-control ${
														formik.touched.execution_time &&
														formik.errors.execution_time
															? "is-invalid"
															: ""
													}`}
													timeIntervals={15}
													timeCaption="Hora"
													dateFormat="HH:mm"
													timeFormat="HH:mm"
													placeholderText="Seleccione una hora"
													name="execution_time"
													filterTime={filterPassedTime}
													minTime={new Date().setHours(
														new Date().getHours(),
														new Date().getMinutes() + 15,
														0,
														0,
													)}
													maxTime={new Date().setHours(23, 59, 0, 0)}
												/>
											</InputGroup>
											{formik.touched.execution_time &&
											formik.errors.execution_time ? (
												<div className="invalid-feedback d-block">
													{formik.errors.execution_time}
												</div>
											) : null}
										</FormGroup>
									</Col>
								</Row>
								<div className="d-flex justify-content-center mt-3">
									<Button
										type="button"
										color="warning"
										className="mb-2 me-2 btn-icon"
										onClick={() => {
											navigate(`/`);
										}}
									>
										<i className="pe-7s-close-circle btn-icon-wrapper"> </i>
										Cancelar
									</Button>
									<Button
										type="submit"
										color="primary"
										className="mb-2 me-2 btn-icon"
									>
										<i className="pe-7s-check btn-icon-wrapper"> </i>
										Actualizar
									</Button>
								</div>
							</Form>
						</CardBody>
					</Card>
				</Row>
			</Container>
		</Fragment>
	);
};

export default TimeChangeJobsClosurePage;
